import { createFileRoute } from "@tanstack/react-router";
import { ReviewNamePlateInfo } from "@/components/installFlowV2/review-name-plate-info";

import { z } from "zod";

export const Route = createFileRoute("/installFlow/review-name-plate-info")({
  component: ReviewNamePlateInfo,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
});
